import { EntryEditor } from './EntryEditor';

export default EntryEditor;
